<template>
  <div class="document-fields">
    <b-field label="Label" label-position="inside">
      <b-input
        :value="label"
        name="label"
        autocomplete="off"
        placeholder="ex: Birth Certificate"
        required
        :readonly="isPreset || isSaving"
        @input="$emit('update:label', $event)"
      />
    </b-field>
    <b-field ref="image-container" class="document-fields-image">
      <ImageUpload
        :value="image"
        :preview-url="previewUrl"
        :disabled="isSaving"
        :readonly="imageReadonly"
        @input="$emit('update:image', $event)"
      />
    </b-field>
  </div>
</template>

<script>
import PresetDocumentLabels from "@/constants/presetDocumentLabels";
import ImageUpload from "@/shared_components/ImageUpload";

export default {
  components: {
    ImageUpload
  },
  props: {
    image: {
      type: File,
      default: null
    },
    previewUrl: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    imageReadonly: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isPreset() {
      return this.label
        ? Object.values(PresetDocumentLabels).includes(this.label)
        : false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "bulma/sass/utilities/mixins.sass";

.document-fields {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  @include tablet() {
    min-height: 430px;
  }
  @include mobile() {
    min-height: 300px;
  }
  &-image {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
  }
}
</style>
